import React,{ useState } from 'react';
import { Navbar,Container,Nav } from 'react-bootstrap';

import header from '../images/header.jpg';

import { Carousel } from 'react-bootstrap';
import Inicio from './Inicio';
import Oferta from './Oferta';
import Contacto from './Contacto';
import Footer from './Footer';
import Alumnos from './Alumnos';


const Index = () =>{
    const [vista, setVista] = useState('Inicio');

    return(    
        <>
        <Carousel>
            <Carousel.Item>
                <img alt="" src={header} style={{width:"100%"}}/>
            </Carousel.Item>
        </Carousel>


        <Navbar collapseOnSelect expand="lg" style={{backgroundColor:"#6F95C6"}}>
            <Container>
            <Navbar.Brand onClick = {() => { setVista('Inicio') } }>
                <b style={{fontSize:30,color:"white"}} >Cetis 158</b>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">
                </Nav>
                <Nav>
                    <Nav.Link onClick = {() => { setVista('Inicio') } }>Inicio</Nav.Link>
                    <Nav.Link onClick = {() => { setVista('Oferta') } }>Oferta educativa</Nav.Link>
                    <Nav.Link onClick = {() => { setVista('Alumnos') } }>Alumnos</Nav.Link>
                    <Nav.Link onClick = {() => { setVista('Contacto') } }>Contacto</Nav.Link>
                </Nav>
            </Navbar.Collapse>
            </Container>
        </Navbar>

        
        {(() => {
        if (vista === 'Inicio') {
        return (
            <Inicio></Inicio>
        )
        }
        if (vista === 'Oferta') {
        return (
            <Oferta/>
        )
        }
        if (vista === 'Contacto') {
            return (
            <Contacto/>
        )
        }
        if (vista === 'Alumnos') {
            return (
            <Alumnos/>
        )
        }
        })()}

        <Footer></Footer>


        </>
    )

}
export default Index;